<template>
  <!-- 底部 -->
    <div class="footer" :class="{'home-footer':$route.name=='index' }">
      <div class="container">
        
        <div class="footer-center">
          <p>地址：广东省文化馆（广州大道中1229号）</p>
          <p>Copyright {{curYear}} GDSCC.CN  All right reserved. 广东省文化馆 版权所有     <span>粤ICP备16019011号-2</span></p>
        </div>
        <div class="footer-right">
          <div class="erweima">
            <img :src="qrcode" alt="">
            <div class="erweima-txt">
              <p>扫一扫<br />
            在手机上浏览</p>
          </div>
          </div>
           <div class="sydwp">
            <img src="@/assets/images/sydw.png" alt="">
          </div>
        </div>
       
      </div>
    </div>
</template>

<script>
import configs from '@/config/config'
export default {
  name: 'Footer',
  props: {
    msg: String
  },
  data(){
    return{
      qrcode: `/images/${process.env.NODE_ENV === 'production' ? qrImg : configs.qrImg}`
      // curYear:new Date().getFullYear()
    }
  },
  computed:{
    curYear(){
      let curYear = new Date().getFullYear()
      if(curYear == 2022){
         return curYear;
      }else{
        return '2022-'+ curYear 
      }
    },
  }
}
</script>
<style scoped >
  .home-footer{
    margin-top: 0;
  }

</style>